class ExternalNotesController {
    /*@ngInject*/
    constructor(EventEmitter) {
        this.EventEmitter = EventEmitter;
    }
    $onInit() {
        this.addExternalNotes = false;
        this.copyNote = false;
        if (this.addNoteLabel == undefined) {
            this.addNoteLabel = "Add External Notes";
        }
        if (this.copyNoteLabel == undefined) {
            this.copyNoteLabel = "Copy to External Notes";
        }
        if (this.externalNoteLabel == undefined) {
            this.externalNoteLabel = "External Notes";
        }
        if (this.externalNote !== undefined && !_.isNull(this.externalNote) && this.externalNote.length > 0) {
            this.addExternalNotes = true;
        }
    }
    toggleAddExternalNotes() {
        if (!this.addExternalNotes) {
            this.externalNote = "";
            this._externalNoteChanged();
        }
    }
    toggleCopyToExternalNotes() {
        if (this.copyNote) {
            this.externalNote = this.note;
        }
        else {
            this.externalNote = "";
        }
        this._externalNoteChanged();
        this._copyNoteChanged();
    }
    onExternalNoteChanged() {
        this.copyNote = false;
        this._externalNoteChanged();
        this._copyNoteChanged();
    }
    _externalNoteChanged() {
        this.onExternalNoteChange(this.EventEmitter({
            externalNote: this.externalNote
        }));
    }
    _copyNoteChanged() {
        this.onCopyNoteChange(this.EventEmitter({ copyNote: this.copyNote }));
    }
    receiveFormalizedComment(event) {
        this.externalNote = event;
        this._externalNoteChanged();
    }
    onVoiceTranscript(transcript) {
        if (this.externalNote) {
            this.externalNote += ' ' + transcript;
        }
        else {
            this.externalNote = transcript;
        }
        this._externalNoteChanged();
    }
}
ExternalNotesController.$inject = ['EventEmitter'];
// import * as TEMPLATE from './external-notes.html';
import * as TEMPLATE from 'raw-loader!./external-notes.html';
export const ExternalNotesComponent = {
    selector: 'externalNotes',
    component: {
        bindings: {
            form: '<',
            note: '<',
            externalNote: '<',
            copyNote: '<',
            addNoteLabel: '@',
            copyNoteLabel: '@',
            externalNoteLabel: '@',
            onExternalNoteChange: '&',
            onCopyNoteChange: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: ExternalNotesController,
        // templateUrl: 'app/shared/externalNotes/external-notes.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=external-notes.component.js.map